import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/saif-dc/Dcastalia/Node JS Projects/ucb/components/research/ForgetPassword.jsx");
;
import(/* webpackMode: "eager" */ "/Users/saif-dc/Dcastalia/Node JS Projects/ucb/components/research/Login.jsx");
